import { call, put, takeEvery } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDanhSachMoMonActionIds,
  IDanhSachMoMonActions,
} from "../../action-types/lop-tin-chi/IDanhSachMoMonActions";
import { rootActions } from "../../actions/rootActions";
import { danhSachMoMonApi } from "../../../api/lop-tin-chi/danhSachMoMonApi";
import { IDanhSachMoMonRequest } from "../../reducer-model/lop-tin-chi/IDanhSachMoMonReducer";
import { Download } from "../../../helpers/download";

const mainAction = rootActions.lopTinChiWrapper.danhSachMoMon;
export function* danhSachMoMon(): any {
  yield takeEvery(
    eDanhSachMoMonActionIds.EXPORT_EXCEL_START,
    exportExcelWorker
  );
}

function* exportExcelWorker(action: IDanhSachMoMonActions): any {
  const res: IBaseRespone = yield call(
    danhSachMoMonApi.ExportExcel,
    action.payload as IDanhSachMoMonRequest
  );
  if (res.is_success) {
    Download.Excel(res.data, "danh_sach_mo_mon.xlsx");
    yield put(mainAction.EXPORT_EXCEL_SUCCESS("Thành công!"));
  } else {
    yield put(mainAction.EXPORT_EXCEL_ERROR(res.message ?? "Có lỗi"));
  }
}
